export function getAll() {
  return [
    {
      value: 0,
      name: "",
      text: "累積金額",
    },
    {
      value: 1,
      name: "",
      text: "消費次數",
    },
    {
      value: 2,
      name: "",
      text: "單筆消費",
    },
  ];
}
